import { render } from "./PortalSidebar.vue?vue&type=template&id=06784fbe"
import script from "./PortalSidebar.vue?vue&type=script&lang=js"
export * from "./PortalSidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__